import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _flags = null;
let _promise = null;

export async function getFlags() {
  if (_flags) return _flags;
  if (!_promise) {
    _promise = axios.get(`${API_URL}/config/flags`)
      .then((r) => { _flags = r.data; return _flags; })
      .catch(() => ({ premium_enabled: false }));
  }
  return _promise;
}
